var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,15.66l3-9a.48.48,0,0,0-.06-.45A.52.52,0,0,0,23.5,6H5.81L4.49.39A.51.51,0,0,0,4,0H.5A.5.5,0,0,0,0,.5.5.5,0,0,0,.5,1H3.6L7.39,17.1a2,2,0,1,0,2.33.9h7.56A2,2,0,1,0,19,17H8.4l-.24-1H20.5A.5.5,0,0,0,21,15.66ZM9,19a1,1,0,1,1-1-1A1,1,0,0,1,9,19Zm11,0a1,1,0,1,1-1-1A1,1,0,0,1,20,19ZM7.93,15,6,7H22.81l-2.67,8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.4f282bbaf74c6ad993a0a15e69ca12af.svg";
export { ForwardRef as ReactComponent };